import capitalize from 'lodash/capitalize';
import {
	NETSALES,
	UNITS,
	GMV,
	ONHANDINVENTORY,
	INTRANSITINVENTORY,
	INSTOCKINVENTORY,
} from '../constants/constant';

export const getKPIName = (kpiName) => {
	if (kpiName === UNITS) {
		return 'units';
	} else if (kpiName === GMV) {
		return 'gmv';
	} else if (kpiName === ONHANDINVENTORY) {
		return ONHANDINVENTORY;
	} else if (kpiName === INTRANSITINVENTORY) {
		return INTRANSITINVENTORY;
	} else if (kpiName === INSTOCKINVENTORY) {
		return INSTOCKINVENTORY;
	}
	return 'netsales';
};

export const chartTitle = (kpiName, isGrid = false) => {
	if (kpiName === UNITS || kpiName === 'UNITS') {
		return UNITS;
	} else if (kpiName === GMV) {
		return GMV;
	} else if (kpiName === ONHANDINVENTORY) {
		return 'On Hand';
	} else if (kpiName === INTRANSITINVENTORY) {
		return 'In Transit';
	} else if (kpiName === INSTOCKINVENTORY) {
		return `In Stock${isGrid ? '' : '%'}`;
	} else {
		return NETSALES;
	}
};

export const getFormattedCategoryname = (category = '') => {
	const stringArray = category.split('-') || [];
	const number = stringArray[0];
	const name =
		stringArray.length === 2
			? stringArray[1].split(' ')?.map((str) => capitalize(str))
			: [];
	return number?.includes('All') ? number : `${number}-${name.join(' ')}`;
};

export const getKeyByValue = (object, value) => {
	return Object.keys(object).find((key) => object[key] === value);
};

export const removeNegativeSignFromNumValues = (value) => {
	return value.startsWith('-') ? value.substring(1) : value;
}
